import { mapCreateCagesRequestToApi, mapCreateCagesResponseToDomain } from '@/domain/cages/mappers';
import type {
    CreateCagesVariables,
    CreatedCagesResult,
    UseCreateManyCagesResult,
} from '@/domain/cages/types';
import type { DomainMutationOptions } from '@/domain/shared/types';
import { useCageController_createManyCages } from '@/services/hooks';
import type { CreateCagesDto, CreateCagesResponse } from '@/services/types';

type UseCreateManyCagesOptions = DomainMutationOptions<
    {
        requestBody: CreateCagesDto;
    },
    CreateCagesResponse
>;

export const useCreateManyCages = (
    options?: UseCreateManyCagesOptions
): UseCreateManyCagesResult => {
    const mutation = useCageController_createManyCages(options);

    const mutateAsync = async (variables: CreateCagesVariables): Promise<CreatedCagesResult> => {
        const { requestBody } = variables;

        const requestBodyToSend: CreateCagesDto = mapCreateCagesRequestToApi(requestBody);

        const result = await mutation.mutateAsync({ requestBody: requestBodyToSend });
        return mapCreateCagesResponseToDomain(result.data);
    };

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: mutation.data ? mapCreateCagesResponseToDomain(mutation.data.data) : undefined,
    };
};
